import { Inject, Component, Optional, Input } from "@angular/core";
import { BaseActionBoxComponent } from "../..";
import { ConfiguratorStore } from "../../../configurator/providers";
import { CodePanelValuesModel } from "./codePanelValueModel";
import { ProductDataStore } from "../../providers/productData";
import { CodePanel } from "../../models";


@Component({
  selector: 'code-action-box',
  templateUrl: './codeActionBoxComponent.html'
})
export class CodeActionBoxComponent extends BaseActionBoxComponent {
  

  @Input()
  valuesModel: CodePanelValuesModel;

  actionBoxTitle: string;

  constructor(
    @Optional() @Inject(ConfiguratorStore) configuratorStore: ConfiguratorStore,
    @Inject(ProductDataStore) private productStore: ProductDataStore) {
    super(configuratorStore);
  }

  public setup(): void {

    let decoation: CodePanel = this.productStore.getEntity<CodePanel>(this.valuesModel.panelId);
    this.actionBoxTitle = decoation.title ? decoation.title : this.strings.Code;
    
  }

  // TODO: Need to remove this
  public shouldBeVisible(): boolean {
    return true;
  }

  

}